import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["error", "context", "customData", "breadcrumbs"];
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import Vue from "vue";
import * as amplitude from "@amplitude/analytics-browser";
import { sessionReplayPlugin } from "@amplitude/plugin-session-replay-browser";
import { VERSION } from "./constants";
import { clearSensitive, jsonErrorReplacer } from "./utils";
let clientEmail;
const eventNames = {
  CREATE_ACCOUNT: "Registration - account created",
  CLIENT_PROFILE_CREATED: "Client profile created",
  REFERRER_CREATED: "referrers created",
  BORROWER_ID_UPLOADED: "Documents - borrower id uploaded",
  CLIENT_PROFILE_NOTES_CREATED: "Client profile notes created",
  CLIENT_PROFILE_FOLLOWUPS_CREATED: "Client profile follow ups created",
  SUBMIT_TO_FILOGIX: "Applications - filogix submitted",
  APPLICATION_COMPLETE: "Applications - applicaction marked complete",
  "mortgage-app-personal": "personal details",
  "mortgage-app-property": "property details",
  "mortgage-app-mortgage": "mortgage details",
  documents: "documents",
  filogix: "filogix"
};
import { chain, lowerCase } from "lodash";
import moment from "moment";
const MAX_BREADCRUMBS = 20;
let breadcrumbs = [];
let appPortalName = "unknown";
let sessionReplayTracking;
const getClientEmail = data => {
  if (data.client_email) {
    clientEmail = data.client_email;
  } else {
    if (!clientEmail) {
      const store = Vue.auth.session.get();
      clientEmail = store.userDetails.email;
    }
  }
  return clientEmail;
};
const getCurrentRouteContext = () => {
  try {
    var _Vue$router;
    const route = (_Vue$router = Vue.router) == null ? void 0 : _Vue$router.currentRoute;
    if (!route) return {};
    return {
      routeName: route.name,
      routePath: route.path,
      routeFullPath: route.fullPath,
      routeParams: clearSensitive(route.params || {}),
      routeQuery: clearSensitive(route.query || {})
    };
  } catch (_unused) {
    return {};
  }
};
const getSessionContext = () => {
  try {
    var _Vue$auth, _Vue$auth$session;
    const session = (_Vue$auth = Vue.auth) == null ? void 0 : (_Vue$auth$session = _Vue$auth.session) == null ? void 0 : _Vue$auth$session.get == null ? void 0 : _Vue$auth$session.get();
    const userDetails = (session == null ? void 0 : session.userDetails) || {};
    const accountDetails = (session == null ? void 0 : session.accountDetails) || {};
    return {
      userId: userDetails.username,
      accountType: userDetails.accountType || accountDetails.accountType,
      accountSubdomain: accountDetails.accountSubdomain
    };
  } catch (_unused2) {
    return {};
  }
};
const normalizeError = error => {
  var _jsonError$responseJS, _jsonError$responseJS2;
  const jsonError = jsonErrorReplacer(error);
  if (typeof jsonError === "string") {
    return {
      errorMessage: jsonError
    };
  }
  return {
    errorName: jsonError == null ? void 0 : jsonError.name,
    errorMessage: (jsonError == null ? void 0 : jsonError.message) || (jsonError == null ? void 0 : jsonError.statusText),
    stack: jsonError == null ? void 0 : jsonError.stack,
    statusCode: jsonError == null ? void 0 : jsonError.status,
    errorCode: (jsonError == null ? void 0 : jsonError.code) || (jsonError == null ? void 0 : (_jsonError$responseJS = jsonError.responseJSON) == null ? void 0 : _jsonError$responseJS.code),
    responseMessage: jsonError == null ? void 0 : (_jsonError$responseJS2 = jsonError.responseJSON) == null ? void 0 : _jsonError$responseJS2.message,
    error: jsonError
  };
};
const buildDiagnosticsData = (data, source, severity) => {
  const {
      error,
      context = {},
      customData = {},
      breadcrumbs: customBreadcrumbs
    } = data,
    rest = _objectWithoutProperties(data, _excluded);
  const contextData = context;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, rest), normalizeError(error || rest)), {}, {
    source,
    severity,
    context: clearSensitive(contextData),
    customData: clearSensitive(customData),
    breadcrumbs: customBreadcrumbs || breadcrumbs
  }, getRouteContextWithLocation()), getSessionContext()), {}, {
    appPortal: appPortalName
  });
};
const getRouteContextWithLocation = () => _objectSpread(_objectSpread({}, getCurrentRouteContext()), {}, {
  currentUrl: window.location.href,
  subdomain: window.location.pathname.replace("/", "")
});
const addBreadcrumb = (eventName, eventType) => {
  var _context;
  const {
    routeName,
    routePath
  } = getCurrentRouteContext();
  breadcrumbs = _sliceInstanceProperty(_context = [...breadcrumbs, {
    eventName,
    eventType,
    timestamp: moment.utc().format("LL LTS"),
    routeName: routeName,
    routePath: routePath
  }]).call(_context, -MAX_BREADCRUMBS);
};
const isSessionReplayEnabled = () => process.env.AMPLITUDE_SESSION_REPLAY_ENABLED !== "false";
export default class Amplitude {
  static init(appPortal = "unknown") {
    appPortalName = appPortal;
    if (isSessionReplayEnabled() && !sessionReplayTracking) {
      sessionReplayTracking = sessionReplayPlugin({
        forceSessionTracking: true,
        debugMode: false,
        privacyConfig: {
          defaultMaskLevel: "medium"
        }
      });
      amplitude.add(sessionReplayTracking);
    }
    amplitude.init(process.env.AMPLITUDE_KEY, undefined, {
      appVersion: VERSION,
      autocapture: {
        attribution: true,
        pageViews: false,
        sessions: false,
        formInteractions: false,
        fileDownloads: false,
        elementInteractions: false,
        frustrationInteractions: false,
        networkTracking: false,
        webVitals: false
      },
      logLevel: amplitude.Types.LogLevel.Error,
      minIdLength: 1
    });
  }
  static startSession({
    userDetails,
    accountDetails
  }) {
    try {
      Amplitude.identifyUser(userDetails, accountDetails);
      amplitude.track("Login - successful");
    } catch (error) {
      console.error(error);
    }
  }
  static endSession(notify = true) {
    try {
      if (notify) amplitude.track("LOGOUT");
      amplitude.setUserId(undefined);
    } catch (error) {
      console.error(error);
    }
  }
  static identifyUser(userDetails, accountDetails) {
    try {
      var _context2;
      const {
        givenName = "",
        familyName = "",
        email = "",
        username = "",
        accountType
      } = userDetails;
      const {
        accountSubdomain = ""
      } = accountDetails;
      const name = _trimInstanceProperty(_context2 = `${givenName} ${familyName}`).call(_context2);
      amplitude.setUserId(username);
      Amplitude.setToIdentityKey(Amplitude.IDENTIFY_NAME, name);
      Amplitude.setToIdentityKey(Amplitude.IDENTIFY_EMAIL, email);
      Amplitude.setToIdentityKey(Amplitude.IDENTIFY_ACCOUNT_TYPE, accountType);
      Amplitude.setToIdentityKey(Amplitude.IDENTITY_SUBDOMAIN, accountSubdomain);
    } catch (error) {
      console.error(error);
    }
  }
  static addToIdentity(key, value) {
    try {
      if (!key || !value) {
        console.warn(`[amplitude] addToIdentity: ignoring ${_JSON$stringify({
          key,
          value
        })} `);
        return;
      }
      const identify = new amplitude.Identify();
      identify.append(key, value);
      amplitude.identify(identify);
    } catch (error) {
      console.error(error);
    }
  }
  static setToIdentityKey(key, value) {
    try {
      if (!key || !value) {
        console.warn(`[amplitude] setToIdentityKey: ignoring ${_JSON$stringify({
          key,
          value
        })} `);
        return;
      }
      const identify = new amplitude.Identify();
      identify.set(key, value);
      amplitude.identify(identify);
    } catch (error) {
      console.error(error);
    }
  }
  static setToIdentityKeyOnce(key, value) {
    try {
      if (!key || !value) {
        console.warn(`[amplitude] setToIdentityKeyOnce: ignoring ${_JSON$stringify({
          key,
          value
        })} `);
        return;
      }
      const identify = new amplitude.Identify();
      identify.setOnce(key, value);
      amplitude.identify(identify);
    } catch (error) {
      console.error(error);
    }
  }
  static updateVisits(delta = 1) {
    try {
      const identify = new amplitude.Identify().add("visits_count", delta);
      amplitude.identify(identify);
    } catch (error) {
      console.error(error);
    }
  }
  static updateCount(attribute, delta = 1) {
    try {
      const eventName = eventNames[attribute] || attribute;
      const identify = new amplitude.Identify().add(eventName, delta);
      amplitude.identify(identify);
    } catch (error) {
      console.error(error);
    }
  }
  static async logEvent(eventType, data = {}) {
    let eventName = "";
    try {
      let eventData = {};
      const currentUrl = window.location.href;
      if (data && data.verb === "post") return;
      if (eventType === "VISIT") {
        eventData = data;
        eventData.action = "visit";
        eventName = chain(data.page).lowerCase().upperFirst().value() + " visited";
        if (data.page === "mortgage-application") {
          data.page === "mortage-app";
          const subPage = chain(data.subpage).lowerCase();
          eventName = eventName.replace("visited", `- ${subPage} visited`);
        }
      } else if (_includesInstanceProperty(eventType).call(eventType, "ERROR")) {
        eventData = buildDiagnosticsData(_objectSpread(_objectSpread({}, data), {}, {
          currentUrl
        }), data.source || (eventType === "API_ERROR" ? "api" : "unknown"), data.severity || "error");
        eventName = eventType;
      } else if (eventType == "CLIENT_ACTION") {
        if (data.page === "submit") return;
        eventName = eventNames[data.event];
        eventData.client_email = getClientEmail(data);
      } else {
        const splitted = eventType.split(" - ");
        eventName = `${splitted[0]}${splitted.length > 1 ? " - " + lowerCase(splitted[1]) : ""}`;
        eventData = data;
      }
      if (eventData) eventData = clearSensitive(eventData);
      eventData.timestamp = moment.utc().format("LL LTS");
      eventData.subdomain = window.location.pathname.replace("/", "");
      eventData.currentUrl = currentUrl;
      eventData.version = VERSION;
      eventData.appPortal = appPortalName;
      eventData = _objectSpread(_objectSpread({}, getCurrentRouteContext()), eventData);
      if (eventData) amplitude.track(eventName, eventData);else amplitude.track(eventName);
      if (!_includesInstanceProperty(eventType).call(eventType, "ERROR")) addBreadcrumb(eventName, eventType);
    } catch (error) {
      console.error("error while reporting to amplitude", error);
    }
  }
  static logUnhandledError(error, context = {}) {
    try {
      const {
        source = "unknown",
        severity = "fatal",
        customData = {}
      } = context;
      Amplitude.logEvent("UNHANDLED_ERROR", {
        error,
        source,
        severity,
        customData
      });
    } catch (amplitudeError) {
      console.error("error while reporting to amplitude", amplitudeError);
    }
  }
  static logHandledError(error, context = {}, clientMessage = "") {
    try {
      const {
        params,
        path,
        target,
        verb,
        customData = {},
        source = "handled",
        severity = "error"
      } = context;
      Amplitude.logEvent("HANDLED_ERROR", {
        error,
        source,
        severity,
        clientMessage,
        context: {
          params,
          path,
          target,
          verb
        },
        customData
      });
    } catch (amplitudeError) {
      console.error("error while reporting to amplitude", amplitudeError);
    } finally {
      console.error(error);
    }
  }
  static logVuexActionError(error, {
    type,
    payload
  } = {}) {
    try {
      Amplitude.logEvent("VUEX_ACTION_ERROR", {
        error,
        source: "vuex",
        severity: "error",
        actions: {
          type,
          payload: _JSON$stringify(payload)
        }
      });
    } catch (amplitudeError) {
      console.error("error while reporting to amplitude", amplitudeError);
    }
  }
  static logVuexActionEvent(message = "", {
    type = "",
    payload = {}
  } = {}) {
    try {
      Amplitude.logEvent(`VUEX_ACTION_EVENT${message ? ` - ${message}` : ""}`, {
        actions: {
          type,
          payload: _JSON$stringify(payload)
        }
      });
    } catch (amplitudeError) {
      console.error("error while reporting to amplitude", amplitudeError);
    }
  }
}
_defineProperty(Amplitude, "IDENTIFY_NAME", "name");
_defineProperty(Amplitude, "IDENTIFY_EMAIL", "email");
_defineProperty(Amplitude, "IDENTIFY_ACCOUNT_TYPE", "account_type");
_defineProperty(Amplitude, "IDENTITY_APPLICATION_IDS", "application_id");
_defineProperty(Amplitude, "IDENTITY_SUBDOMAIN", "subdomain");
_defineProperty(Amplitude, "IDENTIFY_PARENT_CLIENT_USERNAME", "parent_client_username");